module.exports = __webpack_public_path__ + "static/scale-model-of-austin-visitor-center-in-austin-texas-1b12e848422158a691244960ffd9c82c.png";